<template>
  <div>
    <FormItem v-bind="itemProp">
      <draggable :value="value" @input="onDrag" @start="drag=true" @end="drag=false">
        <condition-out-tip
          v-for="(out, index) in value"
          :key="index"
          :conditions="out.conditions"
          :disabled="drag"
        >
        <Tag
          size="medium"
          color="primary"
          closable
          @on-close="delOuts(index)"
        >
          <span style="cursor: pointer;" @click="onEdit(index)">{{ out.name }}</span>
        </Tag>
      </condition-out-tip>
      </draggable>
      <Button shape="circle" type="warning" @click="showAddBranch">增加出口</Button>
    </FormItem>
    <condition-out :ignore="outIds" v-model="showOutModal" :curOut="value[curOutIndex]" @editOut="editOut" />
  </div>

</template>

<script>
import ConditionOut from './ConditionOut.vue';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable'
import ConditionOutTip from './ConditionOutTip.vue';

export default {
  components: {
    ConditionOut,
    draggable,
    ConditionOutTip,
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      showOutModal: false,
      curOutIndex: undefined,
      drag: false
    };
  },
  watch: {
    showOutModal(val) {
      if (!val) {
        this.curOutIndex = undefined
      }
    }
  },
  computed: {
    ...mapGetters('intents', ['intentsMap']),
    itemProp() {
      return {
        label: '出口',
        ...this.formItemProps,
      }
    },
    outIds() {
      return this.value.map(item => item.intent_id)
    }
  },
  methods: {
    showAddBranch() {
      this.showOutModal = true;
    },
    onEdit(index) {
      this.curOutIndex = index;
      this.showAddBranch();
    },
    // 添加 / 编辑分支
    editOut(conditionOutData) {
      if (this.curOutIndex === undefined) {
        this.$emit('change', [...this.value, { ...conditionOutData }])
      } else {
        this.value.splice(this.curOutIndex, 1, { ...this.value[this.curOutIndex], ...conditionOutData })
        this.$emit('change', [...this.value])
      }
    },
		// 删除分支
    delOuts(index) {
      if (~index) {
        this.value.splice(index, 1);
      }
    },
    onDrag(value) {
      this.$emit('change', value)
    }
  }
}
</script>